export default __webpack_public_path__ + "static/media/BOD Special Meeting November 06, 2020.34044a53.pdf";